@if (filteredColorGroups()) {
  <div class="hidden md:block">
    <p-tabView (onChange)="selectedTabChanged($event)">
      @for (group of filteredColorGroups(); track group.groupName) {
        <p-tabPanel
          [header]="group.labelResourceKey | resourceValue"
          [selected]="group.id === selectedColorGroup().id"></p-tabPanel>
      }
    </p-tabView>
  </div>
  <section class="mb-4 block md:hidden">
    <p-button
      data-test-id="favoriteColorsPage.showSortByWindowButton"
      id="ppg-sort-by-button"
      styleClass="w-full text-left"
      [label]="resources.filterHeader | resourceValue"
      [outlined]="true"
      (click)="showOptionSelector = !showOptionSelector"
      icon="pi pi-chevron-down"
      iconPos="right">
    </p-button>
  </section>
  <ppg-colors-grid
    [gridItemStyleClass]="'flex md:block p-2 w-full md:w-6 lg:w-3 xl:w-3 md:col-6 lg:col-3 xl:col-3'"
    [colors]="selectedColorGroup()?.colors"
    [rows]="rowsPerPage()"
    (favoriteColorRemoved)="onFavoriteColorRemoved($event)"
    (favoriteColorAdded)="onFavoriteColorAdded($event)"
    (colorDetailsLinkClicked)="onColorDetailsLinkClicked($event)">
  </ppg-colors-grid>

  <ppg-option-selector-sidebar
    class="block md:hidden"
    (valueChange)="onFilterValueChange($event)"
    (onHide)="showOptionSelector = false"
    [visible]="showOptionSelector"
    [header]="resources.filterHeader | resourceValue"
    styleClass="h-auto"
    [selectedOption]="filterOptions()[activeIndex()]"
    [options]="filterOptions()">
  </ppg-option-selector-sidebar>
}
